import { HttpErrorResponse } from '@angular/common/http';

export interface SubscriptionApiErrorInfo {
  /** i18n key under `common.errors`, ready for `translateService.instant()`. */
  messageKey: string;
  /** True when the caller should re-fetch the relevant provider catalog (networks/tokens) after showing the message. */
  refreshCatalog: boolean;
  /** True when the error should be surfaced to the user (55); false when it should be swallowed/retried silently (56). */
  showToUser: boolean;
}

/**
 * Maps the provider-kill-switch backend contract (AML-1096/1097/1105) errors to a client message.
 * - 409/55: a provider named in the request was disabled after the client cached its catalog —
 *   show an inline message and refresh the catalog so the user can pick again.
 * - 409/56: nothing changed (relevant mainly to the admin screen, not this app) — never show it as
 *   an error, just ignore the duplicate action.
 * Returns null for anything else so callers fall back to their existing handling.
 */
export function getSubscriptionApiErrorMessage(error: HttpErrorResponse): SubscriptionApiErrorInfo | null {
  if (error.status !== 409) {
    return null;
  }

  switch (error.error?.code) {
    case 55:
      return { messageKey: 'common.errors.provider_temporarily_unavailable', refreshCatalog: true, showToUser: true };
    case 56:
      return { messageKey: 'common.errors.nothing_changed', refreshCatalog: false, showToUser: false };
    default:
      return null;
  }
}
